import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import InviteResearcherPage from './InviteResearcherPage.js';

export default WithGASetup(InviteResearcherPage, AuthContext);
